import { MC0655_LIMITS } from '../constants/MC0655Limits';
import { UsageLimitToI18nKey } from '../constants/UsageLimitToI18nKey';
export const filterLimits = usageLimitsResponse => {
  if (!usageLimitsResponse || !usageLimitsResponse.length) {
    return [];
  }
  return usageLimitsResponse.filter(usageLimit => {
    return Object.keys(UsageLimitToI18nKey).includes(usageLimit.limitName);
  });
};
export const sortLimits = usageLimitsResponse => {
  if (!usageLimitsResponse || !usageLimitsResponse.length) {
    return [];
  }
  return usageLimitsResponse.sort((a, b) => a.limitName > b.limitName ? 1 : b.limitName > a.limitName ? -1 : 0);
};
export const filterLimitsByMC0655Eligibility = usageLimitsResponse => usageLimitsResponse.filter(limit => limit.limitName in MC0655_LIMITS);
export const sortLimitsByHigherUsage = usageLimitsResponse => {
  return usageLimitsResponse.sort((a, b) => {
    const limitAUsageRatio = a.usage / a.limit;
    const limitBUsageRatio = b.usage / b.limit;

    //rule exception: if the limit of a limit is 1
    if (a.limit === 1 && b.limit !== 1) {
      //if limit B has any usage, sort it before limit A
      if (limitBUsageRatio) return 1;

      //if limit A has any usage, sort it before limit B
      return limitAUsageRatio ? -1 : 1;
    } else if (a.limit !== 1 && b.limit === 1) {
      //same idea, but limits are inverted so so are the returns
      if (limitAUsageRatio) return -1;
      return limitBUsageRatio ? 1 : -1;
    }

    //sort in descending order of usage ratio
    return limitBUsageRatio - limitAUsageRatio;
  });
};